module.exports = __webpack_public_path__ + "static/media/return-gray.96ab0dfb.svg";